import { render } from "./changeCofreByDocument.vue?vue&type=template&id=31e0cf11&ts=true"
import script from "./changeCofreByDocument.vue?vue&type=script&lang=ts"
export * from "./changeCofreByDocument.vue?vue&type=script&lang=ts"

import "./changeCofreByDocument.vue?vue&type=style&index=0&id=31e0cf11&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__